import { ToastContext } from "@/context/toast/index";
import api from "@/services/api/eclips";
import classname from "classnames";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "@/lib/router-dom/index";

export default function PackageTagCard({ data ,isCopy }) {
	const { t } = useTranslation();
	const { eclipId } = useParams();
	const { addToastMessage } = useContext(ToastContext);

	const [value, setValue] = React.useState("");
	const [tags, setTags] = React.useState(data);

	const [allTags, setAllTags] = React.useState([]);

	const [visible, setVisibility] = React.useState(false);

	const referenceRef = React.useRef(null);
	const popperRef = React.useRef(null);

	const dropdownClass = classname({
		tag__dropdown_content: true,
		"tag__dropdown_content--active": visible,
	});

	const handleInput = (e) => {
		if (e.target?.value?.length > 60) {
			addToastMessage("Maximum length of tag is 60 characters", "error");
			return;
		}
		setValue(e.target.value);
	};

	const handleKeyDown = (e) => {
		if (e.keyCode === 13 && value) {
			const newTag = value.trim();

			if (!tags?.includes(newTag)) {
				const update = [...tags, newTag];
				// add tag on enter
				updateTags(update);
				setTags(update);
				setValue("");
			}
			setValue("");
		}
	};

	const init = () => {
		api.getTags().then((response) => {
			setAllTags(response.data?.data);
		});
	};

	useEffect(() => {
		if (data) {
			setTags(data?.map((tag) => tag.name));
		}
	}, [data]);
	useEffect(init, []);

	const updateTags = async (updatedTags) => {
		await api.createTags(eclipId, updatedTags);
		init();
	};

	const filteredTags = allTags
		?.filter(
			(tag) => !tags?.includes(tag?.name) && tag?.name?.includes(value)
		)
		?.slice(0, 5);

	return (
		<div className="eclip-tag">
			<div className="eclip-tag__title">Package Tag</div>
			<div className="eclip-tag__selected">
				<div className="eclip-tag__label">Label</div>
				<div
					onClick={(e) => {
						if (e.isPropagationStopped()) return;

						document.getElementById("package-tag-input").focus();
					}}
					className={`eclip-tag__input-container ${isCopy && 'disabled'}`}
				>
					{tags?.map((tag, index) => (
						<div className="eclip-tag__tag" key={index}>
							<span className="text trim--two-lines">{tag}</span>
							<span
								className="eclip-tag__tag-remove"
								onClick={(e) => {
									e.stopPropagation();
									// remove tag
									const update = tags.filter(
										(t) => t !== tag
									);
									setTags(update);
									updateTags(update);
								}}
							>
								x
							</span>
						</div>
					))}
					<div className="eclip-tag__input">
						<input
							autoComplete="off"
							name="package-tag-input"
							onFocus={() => {
								setVisibility(true);
							}}
							onBlur={() => {
								setTimeout(() => {
									setVisibility(false);
								}, 200);
							}}
							id="package-tag-input"
							type="text"
							data-testid="inputtxt"
							value={value}
							onChange={handleInput}
							onKeyDown={handleKeyDown}
							disabled={isCopy}
						/>
					</div>
				</div>
				<div className="tag__dropdown_container">
					{visible && filteredTags?.length > 0 && (
						<div className={dropdownClass}>
							{filteredTags.map((tag, index) => (
								<div
									className={
										"eclip-tag__suggestion trim--two-lines" +
										(value?.toLowerCase() ===
										tag?.name?.toLowerCase()
											? "eclip-tag__suggestion--active"
											: "")
									}
									key={tag.id}
									onClick={(e) => {
										e.stopPropagation();
										// click on the tag to add it
										const update = [...tags, tag.name];
										setTags(update);
										setValue("");
										updateTags(update);
									}}
								>
									{tag.name}
								</div>
							))}
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
